import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { CreateChannelFlowRequestFilterSensitiveLog, } from "../models/models_0";
import { de_CreateChannelFlowCommand, se_CreateChannelFlowCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class CreateChannelFlowCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "CreateChannelFlow", {})
    .n("ChimeSDKMessagingClient", "CreateChannelFlowCommand")
    .f(CreateChannelFlowRequestFilterSensitiveLog, void 0)
    .ser(se_CreateChannelFlowCommand)
    .de(de_CreateChannelFlowCommand)
    .build() {
}
